import Parent from "parentjs/controllers/modal_controller.js";
export default Parent;
